
export function updateState(that:any, attr:any, value:any) {
	var currentState = that.state;
	var newState = Object.assign(currentState);
	newState[attr] = value;
	that.setState(newState);
}

export function upsertStateIn(that:any, attr:any, updatedNewItem:any) {
	let upsertCandidateArray = that.state[attr];
    let indexOfUpsertCandidateItem = upsertCandidateArray.findIndex((o:any) => o.id == updatedNewItem.id);
    upsertCandidateArray[indexOfUpsertCandidateItem] = updatedNewItem;
      
	var currentState = that.state;
	var newState = Object.assign(currentState);
	newState[attr] = upsertCandidateArray;
	that.setState(newState);
}

export function loadingStart(that:any) {
	var currentState = that.state;
	var newState = Object.assign(currentState);
	newState["isLoading"] = true;
	that.setState(newState);
}

export function loadingComplete(that:any) {
	var currentState = that.state;
	var newState = Object.assign(currentState);
	newState["isLoading"] = false;
	that.setState(newState);
}